<script>
  import { ui } from "../store.js";
  import { AppController } from '../AppController';
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
  } from "sveltestrap";
  import { createEventDispatcher } from 'svelte';

  export let resident;

  const dispatch = createEventDispatcher();

  const hide = () => AppController.displayDeleteResidentModal(false);
  
  const del = () => {
    dispatch('delete', resident);
    hide();
  }
</script>

<Modal isOpen={$ui.displayDeleteResidentModal} {hide}>
  <ModalHeader {hide}>Delete Resident</ModalHeader>
  <ModalBody>
    Are you sure you want to permanently delete {resident.first_name} {resident.last_name}? 
  </ModalBody>
  <ModalFooter>
    <Button color="danger" on:click={del}>
      Delete
    </Button>
    <Button color="secondary" on:click={hide}>
      Cancel
    </Button>
  </ModalFooter>
</Modal>

